

import Select, { components } from 'react-select';
import { DropdownProps, DropdownWrapper, OptionIcon } from './Dropdown';
import styled from 'styled-components';

const OptionColor = styled.div<{ color: string }>`
    background: ${(p) => p.color};
    height: 46px;
    width: 4px;
    position: absolute;
    left: 0;
    top: 1px;
`;
const OptionColorRounded = styled.div<{ color: string }>`
    background: ${(p) => p.color};
    height: 48px;
    width: 4px;
    position: absolute;
    left: 0;
    top: -1px;

    border-radius: 3px 0px 0px 3px;
`;

export const ValueContainer = (props: any) => {
    const options: any[] = props.options;
    const currentOption = options.find(
        (v: any) => props.getValue() && props.getValue()[0] && v.value === props.getValue()[0].value,
    );
    return (
        <>
            {currentOption && currentOption.color && <OptionColorRounded color={currentOption.color} />}
            <components.ValueContainer {...props} />
        </>
    );
};

export const Option = (props: any) => (
    <components.Option {...props}>
        {props && props.data.color && <OptionColor color={props.data.color} />}
        {props.children}
        {props.isSelected && (
            <OptionIcon>
                <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M0.406428 4.07812L4.02859 7.67898L10.6763 1.05256L9.84535 0.22159L4.02859 6.01705L1.21609 3.24716L0.406428 4.07812Z"
                        fill="#FEFEFE"
                    />
                </svg>
            </OptionIcon>
        )}
    </components.Option>
);

function Indicator(p: any) {
    return (
        <components.DropdownIndicator {...p}>
            <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.64575 7.64588L0.636039 1.63617L1.34432 0.927891L6.99991 6.58349L12.6557 0.927918L13.3639 1.63618L7.35401 7.64587L6.99987 8L6.64575 7.64588Z"
                    fill="#FEFEFE"
                />
            </svg>
        </components.DropdownIndicator>
    );
}

function Menu(p: any) {
    return (
        <components.Menu {...p}>
            {p.children}
            {/*<MenuListShadow/>*/}
        </components.Menu>
    );
}

export function DropdownEditable(props: DropdownProps) {
    return (
        <DropdownWrapper>
            <Select
                components={{
                    DropdownIndicator: Indicator,
                    Menu: Menu,
                    ValueContainer,
                    Option,
                }}
                cacheOptions
                maxMenuHeight={172}
                className={'brg-autofill'}
                classNamePrefix={'brg-input'}
                noOptionsMessage={() => 'No such position'}
                isSearchable={true}
                isClearable={false}
                {...props}
            />
        </DropdownWrapper>
    );
}


import Select, { components } from 'react-select';
import { DropdownProps, DropdownWrapper, OptionIcon } from './Dropdown';
import styled from 'styled-components';

const OptionColor = styled.div<{ color: string }>`
    background: ${(p) => p.color};
    height: 46px;
    width: 4px;
    position: absolute;
    left: 0;
    top: 1px;
`;
const OptionColorRounded = styled.div<{ color: string }>`
    background: ${(p) => p.color};
    height: 48px;
    width: 4px;
    position: absolute;
    left: 0;
    top: -1px;

    border-radius: 3px 0px 0px 3px;
`;

export const ValueContainer = (props: any) => {
    const options: any[] = props.options;
    const currentOption = options.find(
        (v: any) => props.getValue() && props.getValue()[0] && v.value === props.getValue()[0].value,
    );
    return (
        <>
            {currentOption && currentOption.color && <OptionColorRounded color={currentOption.color} />}
            <components.ValueContainer {...props} />
        </>
    );
};

export const Option = (props: any) => (
    <components.Option {...props}>
        {props && props.data.color && <OptionColor color={props.data.color} />}
        {props.children}
        {props.isSelected && (
            <OptionIcon>
                <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M0.406428 4.07812L4.02859 7.67898L10.6763 1.05256L9.84535 0.22159L4.02859 6.01705L1.21609 3.24716L0.406428 4.07812Z"
                        fill="#FEFEFE"
                    />
                </svg>
            </OptionIcon>
        )}
    </components.Option>
);

function Indicator(p: any) {
    return (
        <components.DropdownIndicator {...p}>
            <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.64575 7.64588L0.636039 1.63617L1.34432 0.927891L6.99991 6.58349L12.6557 0.927918L13.3639 1.63618L7.35401 7.64587L6.99987 8L6.64575 7.64588Z"
                    fill="#FEFEFE"
                />
            </svg>
        </components.DropdownIndicator>
    );
}

function Menu(p: any) {
    return (
        <components.Menu {...p}>
            {p.children}
            {/*<MenuListShadow/>*/}
        </components.Menu>
    );
}

export function DropdownEditable(props: DropdownProps) {
    return (
        <DropdownWrapper>
            <Select
                components={{
                    DropdownIndicator: Indicator,
                    Menu: Menu,
                    ValueContainer,
                    Option,
                }}
                cacheOptions
                maxMenuHeight={172}
                className={'brg-autofill'}
                classNamePrefix={'brg-input'}
                noOptionsMessage={() => 'No such position'}
                isSearchable={true}
                isClearable={false}
                {...props}
            />
        </DropdownWrapper>
    );
}
